import { PAGES } from '@ats/constants';
import InterviewerAuthenticatedLayout from '@layout/Authenticated/Interviewer';
import ErrorLayout from '@layout/Error';
import InterviewerLayout from '@layout/Interviewer';
import ModalLayout from '@layout/Modal';
import InterviewerSettingLayout from '@layout/Setting/Interviewer';
import CheckBrowserPage from '@pages/CheckBrowser';
import CheckDevicePage from '@pages/CheckDevice';
import InterviewerHomePage from '@pages/Interviewer/Home';
import InterviewerRoomPage from '@pages/Interviewer/Room';
import InterviewerSettingPage from '@pages/Interviewer/Setting';
import InterviewerWaitingPage from '@pages/Interviewer/Waiting';
import type { RouteObject } from 'react-router';

const InterviewerRoute: RouteObject = {
  path: PAGES.VIDEO_INTERVIEW.INTERVIEWER.HOME,
  element: (
    <ModalLayout>
      <InterviewerLayout />
    </ModalLayout>
  ),
  children: [
    {
      index: true,
      element: <InterviewerHomePage />,
    },
    {
      path: PAGES.VIDEO_INTERVIEW.INTERVIEWER.WAITING,
      element: (
        <InterviewerAuthenticatedLayout>
          <InterviewerWaitingPage />
        </InterviewerAuthenticatedLayout>
      ),
    },
    {
      path: PAGES.VIDEO_INTERVIEW.INTERVIEWER.ROOM,
      element: (
        <InterviewerAuthenticatedLayout>
          <InterviewerRoomPage />
        </InterviewerAuthenticatedLayout>
      ),
    },
    {
      path: PAGES.VIDEO_INTERVIEW.INTERVIEWER.SETTING,
      element: <InterviewerSettingLayout />,
      children: [
        {
          index: true,
          element: <InterviewerSettingPage />,
        },
      ],
    },
    {
      path: PAGES.VIDEO_INTERVIEW.INTERVIEWER.CHECK_BROWSER,
      element: <ErrorLayout />,
      children: [
        {
          index: true,
          element: <CheckBrowserPage />,
        },
      ],
    },
    {
      path: PAGES.VIDEO_INTERVIEW.INTERVIEWER.CHECK_DEVICE,
      element: <ErrorLayout />,
      children: [
        {
          index: true,
          element: <CheckDevicePage />,
        },
      ],
    },
  ],
};

export default InterviewerRoute;
